
import React, { useEffect, useState, useRef } from 'react';
import styled from "@emotion/styled";
import { motion } from "framer-motion";
import { useTranslation } from 'react-i18next';
import { ReactComponent as PlusIcon } from "../assets/svgs/plus.svg";
import { ReactComponent as TrashIcon } from "../assets/svgs/delete.svg";
import { ReactComponent as UpIcon } from "../assets/svgs/up.svg";
import { ReactComponent as DownIcon } from "../assets/svgs/down.svg";
import { ReactComponent as Close } from "../assets/svgs/close-x.svg";
import { ReactComponent as Edit } from "../assets/svgs/edit.svg";
import { ReactComponent as MapViewPin } from "../assets/svgs/map-view-pin.svg";

const ModalContainer = styled(motion.div)`
  
  position: fixed;
  top: 0;
  right: 0;
  width: 40vw;
  height: 100vh;
  background: white;
  box-shadow: -4px 0 10px rgba(0, 0, 0, 0.2);
  padding: 50px 20px;
  display: flex;
  flex-direction: column;
    z-index: 100000;
  // z-index: 9999;
  overflow-y: auto;
  ::-webkit-scrollbar { width: 8px; }
  ::-webkit-scrollbar-thumb { background-color: #91abb3; border-radius: 10px; }
  ::-webkit-scrollbar-track { background: #f5f5f5; border-radius: 10px; }

  @media (max-width: 768px) {
    width: 70vw;
    padding: 30px 15px;
  }

  @media (max-width: 480px) {
    width: 90vw;
    padding: 20px 10px;
  }
`;

const TabSwitcher = styled.div`
  display: flex;
  border-bottom: 1px solid #ccc;
  margin-bottom: 40px;
  flex-wrap: wrap;
`;

const Tab = styled.div`
  padding: 10px 20px;
  cursor: pointer;
  font-weight: ${props => props.active ? 'bold' : 'normal'};
  border-bottom: ${props => props.active ? '2px solid #385963' : 'none'};
  color: ${props => props.active ? '#385963' : '#888'};


  
  @media (max-width: 768px) {
    padding: 8px 15px;
     font-size:${props => props.active ? '14px' : '12px'};
  }

  @media (max-width: 480px) {
    padding: 6px 12px;
    font-size:${props => props.active ? '12px' : '10px'};
  }
  }
`;

const Title = styled.div`
  font-size: 20px;
  color: #385963;
  font-weight: 600;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    font-size: 18px;
  }

  @media (max-width: 480px) {
    font-size: 16px;
  }
`;

const PlanName = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 30px;
  gap: 10px;

  @media (max-width: 768px) {
    margin-bottom: 20px;
  }

  @media (max-width: 480px) {
    margin-bottom: 15px;
  }
`;

const PlanTitle = styled.div`
  font-size: 16px;
  color: #385963;

  @media (max-width: 768px) {
    font-size: 14px;
  }

  @media (max-width: 480px) {
    font-size: 12px;
  }
`;

const PlanNameField = styled.input`
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
  width: 100%;
 color: #385963;

  @media (max-width: 768px) {
    font-size: 14px;
  }

  @media (max-width: 480px) {
    font-size: 12px;
  }
`;

const InputContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  // margin-bottom: 10px;
  margin:  20px 5px;

  span{
    font-size:12px;
  }

  @media (max-width: 768px) {
    gap: 8px;
  }

  @media (max-width: 480px) {
    gap: 6px;
  }
`;

const InputField = styled.input`
  flex: 1;
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 5px;

  @media (max-width: 768px) {
    font-size: 14px;
  }

  @media (max-width: 480px) {
    font-size: 12px;
  }
`;

const IconButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
`;

const ButtonFlex = styled.div`
  display: flex;
  gap: 15px;
  margin-top: 30px;
  justify-content: center;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    gap: 10px;
  }

  @media (max-width: 480px) {
    gap: 8px;
  }
`;

const Button = styled.button`
  background-color: white;
  color: #385963;
  font-weight: 400;
  font-size: 12px;
  border: 2px solid #385963;
  width: 120px;
  padding: 5px;
  border-radius: 10px;

  &:hover {
    box-shadow: rgba(0, 0, 0, 0.2) 0px 10px 40px;
    color: white;
    transition: 0.4s;
    cursor: pointer;
    background-color: #385963;
  }

  @media (max-width: 768px) {
    font-size: 14px;
    width: auto;
  }

  @media (max-width: 480px) {
    font-size: 12px;
    padding: 4px 8px;
  }
`;

const CloseButton = styled.button`
  background-color: white;
  color: #385963;
  font-weight: 400;
  border: none;
  width: auto;
  padding: 5px;
  border-radius: 10px;

  @media (max-width: 768px) {
    font-size: 10px;
  }

  @media (max-width: 480px) {
    font-size: 8px;
  }
`;

const DropdownContainer = styled.div`
  position: absolute;
  top: ${({ top }) => top + 5}px;
  width: 100%;
  background: white;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  max-height: 200px;
  overflow-y: auto;
  z-index: 1;
`;

const DropdownItem = styled.div`
  padding: 10px;
  cursor: pointer;
  &:hover { background-color: #f0f0f0; }
`;

const ListFlexButtons = styled.div`
  display: flex;
  gap: 10px;
`;

const HeaderRight = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
    transition: 0.4s;
    cursor: pointer;
  }

  @media (max-width: 768px) {
    font-size: 12px;
  }

  @media (max-width: 480px) {
    font-size: 10px;
  }
`;

const PlansList = styled.ol`
 padding-left: 20px;
`;

const PlanItem = styled.li`
 margin-bottom: 20px;

 @media (max-width: 768px) {
  font-size: 16px;
}

@media (max-width: 480px) {
  font-size: 12px;
}
`;



const UpdateButton = styled.button`
  background-color: #4caf50;
  color: white;
  font-size: 14px;
  border: none;
  padding: 10px;
  border-radius: 8px;
  cursor: pointer;
  margin-top: 10px;
  transition: background-color 0.2s;

  &:hover {
    background-color: #388e3c;
  }
`;


const ClearButton = styled.button`
  background-color: #e53935;
  color: white;
  font-size: 14px;
  border: none;
  padding: 10px;
  border-radius: 8px;
  cursor: pointer;
  margin-top: 10px;
  transition: background-color 0.2s;

  &:hover {
    background-color: #c62828;
  }
`;



const TripPlanModal = ({ isOpen, onClose, destinations, experiences, amenities,  onShowPlanOnMap, togglePlanMarkers,  planMarkersVisible}) => {

  const mapTypeToEnum = (type) => {
  switch(type) {
    case "destination": return 0;
    case "amenity": return 1;
    case "experience": return 2;
    case "event": return 3;
    default: return 0; // fallback
  }
};

  const loggedIn = sessionStorage.getItem("loggedIn"); 
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const tokenString = sessionStorage.getItem("token");
  const { i18n } = useTranslation();
  const selectedLanguage = sessionStorage.getItem('selectedLanguage') || 'en';
  const [activeTab, setActiveTab] = useState('create');
  const [planName, setPlanName] = useState("");
  const [fields, setFields] = useState([{ id: 1, value: "", selectedId: "", selectedName: "" }]);
  const [inputValue, setInputValue] = useState("");
  const [activeField, setActiveField] = useState(null);
  const [dropdownPosition, setDropdownPosition] = useState(0);
  const fieldDropDownRef = useRef(null);
   const [searchTerm, setSearchTerm] = useState("");
const userRole = sessionStorage.getItem("userRole");

  
  // const [savedPlans, setSavedPlans] = useState([]);
  const [savedPlans, setSavedPlans] = useState([]);
  const [editingPlanId, setEditingPlanId] = useState(null);
  const [loadingPlans, setLoadingPlans] = useState(false);

useEffect(() => {
  if (loggedIn) {
    fetchPlans();
  } else {
    setSavedPlans([]); // Clear plans if logged out
  }
}, [loggedIn]);

const fetchPlans = async () => {
  setLoadingPlans(true);
  try {
    const response = await fetch(`${BASE_URL}Itinerary/getByUser`, {
       headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${tokenString}`,
        },
    });
    if (response.ok) {
      const data = await response.json();
      const formattedPlans = data.map((plan) => ({
          id: plan.id,
          name: plan.name,
          fields: Object.values(plan.details).map((detail, index) => ({
            id: index + 1,
            selectedId: detail.id,
            selectedName:
              detail.name?.[selectedLanguage] || 
              detail.name?.en || 
              detail.name?.gr || 
              "",  // fallback if all null
            type: detail.type === 0 ? "destination" : detail.type === 1 ? "experience" : "amenity",
          })),
        }));

      setSavedPlans(formattedPlans);
    } else {
      console.error("Failed to fetch plans");
    }
  } catch (err) {
    console.error("Error fetching plans:", err);
  } finally {
    setLoadingPlans(false);
  }
};
    
      //TODO: add location property !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
      const allOptions = [
        ...destinations.map((item) => ({
          id: item.id,
          name: item.name[selectedLanguage],
          type: "destination",
          location: item.location 
        })),
        ...experiences.map((item) => ({
          id: item.id,
          name: item.name[selectedLanguage],
          type: "experience",
          location: item.location 
        })),
        ...amenities.map((item) => ({
          id: item.id,
          name: item.name[selectedLanguage],
          type: "amenity",
          location: item.location 
        }))
      ];
    
      useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
      }, []);
    
      const handleClickOutside = (event) => {
        if (fieldDropDownRef.current && !fieldDropDownRef.current.contains(event.target)) {
          setActiveField(false);
        }
      };
    


       // Filter options by searchTerm like ManageAmenities example
  const filteredOptions = searchTerm
    ? allOptions.filter(option =>
        option.name.toLowerCase().includes(searchTerm.toLowerCase())
      )
    : allOptions;

  const handleInputChange = (e, fieldId) => {
    setActiveField(fieldId);
    setSearchTerm(e.target.value);
    setDropdownPosition(e.target.getBoundingClientRect().bottom);
  };


const handleDropdownChange = (selectedOption) => {
  const updatedFields = fields.map(field =>
    field.id === activeField
      ? {
          ...field,
          value: selectedOption.name,
          selectedId: selectedOption.id,
          selectedName: selectedOption.name,
          type: selectedOption.type, // store as string: "destination", "experience", etc.
          location: selectedOption.location,
        }
      : field
  );
  setFields(updatedFields);
  setSearchTerm("");
  setActiveField(null);
};


    
      const addField = (index) => {
        const newField = { id: Date.now(), value: "" };
        const updatedFields = [...fields];
        updatedFields.splice(index + 1, 0, newField);
        setFields(updatedFields);
      };
    
      const removeField = (id) => {
        const updatedFields = fields.filter((field) => field.id !== id);
        setFields(updatedFields);
      };
    
      const moveField = (index, direction) => {
        const updatedFields = [...fields];
        const [movedField] = updatedFields.splice(index, 1);
        updatedFields.splice(index + direction, 0, movedField);
        setFields(updatedFields);
      };
    
      const resetForm = () => {
        setPlanName("");
        setFields([{ id: 1, value: "", selectedId: "", selectedName: "" }]);
        setEditingPlanId(null);
      };
    
      const removeEmptyFields = (fields) => {
        return fields.filter(field => field.selectedId && field.selectedName);
      };
    
      const handleEditPlan = (plan) => {
        setEditingPlanId(plan.id);
        setPlanName(plan.name);
        setFields(plan.fields);
        setActiveTab("create");
      };
    
      const handleCancelEdit = () => {
        resetForm();
        setActiveTab("view");
      };
    

  const getPlanPoints = (plan) => {
  // Assuming each plan has a `points` array with latitude, longitude, name, etc.
  return plan.points.map(point => ({
    id: point.id,
    name: point.name,
    latitude: point.latitude,
    longitude: point.longitude,
    type: point.type,
  }));
};



const handleSavePlan = async () => {
  const cleanedFields = removeEmptyFields(fields);

  const uniqueFields = cleanedFields.filter(
    (field, index, self) =>
      self.findIndex(f => f.selectedId === field.selectedId) === index
  );

  if (!planName.trim() || uniqueFields.length === 0) {
    alert("Please provide a plan name and at least one point.");
    return;
  }

  const details = {};
  uniqueFields.forEach((field, index) => {
    const matchedOption = allOptions.find(opt => opt.id === field.selectedId);

    details[(index + 1).toString()] = {  // keys like "1", "2", ...
      id: matchedOption?.id || field.selectedId, // string GUID expected
      type: mapTypeToEnum(field.type),
      name: {
        gr: "", // or provide if available
        en: matchedOption?.name || field.selectedName || "",
      },
      location: matchedOption?.location || { longitude: 0, latitude: 0 },
      model: 0, // add if required
    };
  });

  const payload = {
    name: planName.trim(),
    details,
  };

  try {
    const response = await fetch(`${BASE_URL}Itinerary`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${tokenString}`,
      },
      body: JSON.stringify(payload),
    });

    if (response.ok) {
      alert("Plan saved successfully!");
      resetForm();
      fetchPlans();
    } 
    // else {
    //   const errorData = await response.json();
    //   console.error("API Error:", errorData);
    //   alert("Failed to save plan. See console for details.");
    // }

    if (!response.ok) {
  let errorMessage = `Error: ${response.status}`;
  try {
    const errorData = await response.json();
    errorMessage = errorData.message || JSON.stringify(errorData);
  } catch (e) {
    // No JSON body, skip parsing
  }
  console.error("API Error:", errorMessage);
  alert("Failed to save plan. " + errorMessage);
  return;
}

  } catch (error) {
    console.error("Error saving plan:", error);
    alert("An unexpected error occurred.");
  }
};

const handleUpdatePlan = async () => {
  const cleanedFields = removeEmptyFields(fields);
  if (!planName || cleanedFields.length === 0) {
    alert("Please provide a plan name and at least one point.");
    return;
  }

  const details = {};
  cleanedFields.forEach((field, index) => {
   details[(index + 1).toString()]  = {
      id: field.selectedId,
      type: mapTypeToEnum(field.type),  // <--- use mapTypeToEnum here as well
      name: {
        gr: "",
        en: field.selectedName,
      },
      location: allOptions.find((opt) => opt.id === field.selectedId)?.location || { longitude: 0, latitude: 0 },
    };
  });

  const payload = {
    name: planName,
    details,
  };

  try {
    const response = await fetch(`${BASE_URL}Itinerary/${editingPlanId}`, {
      method: "PUT",
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${tokenString}`,
      },
      body: JSON.stringify(payload),
    });

    if (response.ok) {
      alert("Plan updated successfully!");
      resetForm();
      fetchPlans();
      setActiveTab("view");
    } else {
      alert("Failed to update plan");
    }
  } catch (error) {
    console.error("Error updating plan:", error);
  }
};


const handleDeletePlan = async (id) => {
  if (!window.confirm("Are you sure you want to delete this plan?")) return;

  try {
    const response = await fetch(`${BASE_URL}Itinerary/${id}`, {
      method: "DELETE",
      headers: {
         'Content-Type': 'application/json',
         Authorization: `Bearer ${tokenString}`,
       },
    });

    if (response.ok) {
      alert("Plan deleted");
      fetchPlans();
    } else {
      alert("Failed to delete plan");
    }
  } catch (error) {
    console.error("Error deleting plan:", error);
  }
};


const detailsToFieldsArray = (details) => {
  if (!details) return [];

  return Object.keys(details).map(key => {
    const detail = details[key];
    return {
      id: key,
      selectedId: detail.id,
      selectedName: detail.name?.en || "",
      type: ["destination", "amenity", "experience", "event"][detail.type] || "destination",
      location: detail.location || { longitude: 0, latitude: 0 },
    };
  });
};

const handleViewToMap = () => {
  const cleanedFields = removeEmptyFields(fields);

  if (cleanedFields.length === 0) {
    alert("Please select at least one point to view on map.");
    return;
  }

  // Build details object as expected by the map component or backend
  const details = {};

  cleanedFields.forEach((field, index) => {
    const matchedOption = allOptions.find(opt => opt.id === field.selectedId);

    details[(index + 1).toString()] = {
      id: matchedOption?.id || field.selectedId,
      type: mapTypeToEnum(field.type), // 0 for destination, 1 for amenity, etc.
      name: {
        gr: "", // Greek name if any
        en: matchedOption?.name || field.selectedName || "",
      },
      location: matchedOption?.location || { longitude: 0, latitude: 0 },
    };
  });

  const planObject = {
    name: planName || "Untitled Plan",
    details,
    fields: detailsToFieldsArray(details),  // <-- add this line
  };

  // Pass the plan object with fields array included
  onShowPlanOnMap(planObject);
};



  return (
    <ModalContainer
      initial={{ x: "100%", opacity: 0 }}
      animate={{ x: isOpen ? "0%" : "100%", opacity: isOpen ? 1 : 0 }}
      transition={{ duration: 0.3 }}
    >
      <TabSwitcher>
        <Tab active={activeTab === 'create'} onClick={() => setActiveTab('create')}>
          {editingPlanId ? i18n.t("editPlan") : i18n.t("newPlan")}
        </Tab>
        {loggedIn &&  userRole==='RegisteredUser' &&(
          <Tab active={activeTab === 'view'} onClick={() => setActiveTab('view')}>
            {i18n.t("savedPlans")}
          </Tab>
        )}
        <HeaderRight onClick={onClose}>
          <Close height={15} width={15}/>
          <CloseButton style={{ padding: '5px 10px' }}>
            {i18n.t('close')}
          </CloseButton>
        </HeaderRight>
      </TabSwitcher>



  {activeTab === "create" && (
        <>
          <Title>{i18n.t("tripPlan")}</Title>
          <PlanName>
            <PlanTitle>{i18n.t("title")}:</PlanTitle>
            <PlanNameField
              type="text"
              placeholder={i18n.t("")}
              value={planName}
              onChange={(e) => setPlanName(e.target.value)}
            />
          </PlanName>

          <PlanTitle>{i18n.t("points")}:</PlanTitle>
          {fields.map((field, index) => (
            <InputContainer key={field.id}>
              <span>{index + 1}</span>
              <InputField
                value={activeField === field.id ? searchTerm : field.selectedName}
                onChange={(e) => handleInputChange(e, field.id)}
                placeholder={i18n.t("search")}
              />
              {activeField === field.id && searchTerm && (
                <DropdownContainer top={dropdownPosition} ref={fieldDropDownRef}>
                  {filteredOptions.length === 0 ? (
                    <DropdownItem style={{ textAlign: "center", color: "gray" }}>
                      {i18n.t("noResultsFound")}
                    </DropdownItem>
                  ) : (
                    filteredOptions.map((option) => (
                      <DropdownItem
                        key={option.id}
                        onClick={() => handleDropdownChange(option)}
                      >
                        {option.name}
                      </DropdownItem>
                    ))
                  )}
                </DropdownContainer>
              )}
              {/* Your buttons for add/remove/move fields */}
              <IconButton onClick={() => addField(index)}>
                <PlusIcon height={15} width={15} />
              </IconButton>
              {fields.length > 1 && (
                <IconButton onClick={() => removeField(field.id)}>
                  <TrashIcon height={15} width={15} />
                </IconButton>
              )}
              {index > 0 && (
                <IconButton onClick={() => moveField(index, -1)}>
                  <UpIcon height={15} width={15} />
                </IconButton>
              )}
              {index < fields.length - 1 && (
                <IconButton onClick={() => moveField(index, 1)}>
                  <DownIcon height={15} width={15} />
                </IconButton>
              )}
            </InputContainer>
          ))}
          <ButtonFlex>
            {editingPlanId ? (
              <>
                <UpdateButton onClick={handleUpdatePlan}>{i18n.t('update')}</UpdateButton>
                <ClearButton onClick={handleCancelEdit}>{i18n.t('cancel')}</ClearButton>
              </>
            ) : (
              <> 
              {loggedIn && userRole === 'RegisteredUser' && (
                 <Button onClick={handleSavePlan}>{i18n.t('save')}</Button>
               )}
               {(!loggedIn ||  userRole === 'Provider' ||  userRole === 'preApprovedProvider') && (
                 <>
                   <Button onClick={handleViewToMap}>{i18n.t('viewToMap')}</Button>
                   <Button onClick={() => {
                     resetForm();
                     onShowPlanOnMap(null);
                   }}>
                     {i18n.t('clear')}
                   </Button>
                 </>
               )}
              </>
            )}
         
          </ButtonFlex>
        </>
      )}



      {activeTab === 'view' && loggedIn && userRole === 'RegisteredUser' && (
        <div>
          {savedPlans.length === 0 ? (
            <div>{i18n.t('noPlansAvailable')}</div>
          ) : (
            <PlansList >
              {savedPlans.map((plan, index) => (
                <PlanItem key={plan.id}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Title>{plan.name}</Title>
                    <ListFlexButtons>
                       <IconButton onClick={() => togglePlanMarkers(plan)} >
                          <MapViewPin height={20} width={20} />
                             <span style={{ marginLeft: '8px' }}>
                              {/* {planMarkersVisible ? i18n.t('hide') : i18n.t('view')} */}
                               {planMarkersVisible === plan.id ? i18n.t('hide') : i18n.t('view')}
                             </span>
                        </IconButton>
                      <IconButton onClick={() => handleEditPlan(plan)}><Edit height={20} width={20} /></IconButton>
                      <IconButton onClick={() => handleDeletePlan(plan.id)}><TrashIcon height={20} width={20} /></IconButton>
                    </ListFlexButtons>
                  </div>
                </PlanItem>
              ))}
            </PlansList>
          )}
        </div>
      )}
    </ModalContainer>
  );
};

export default TripPlanModal;




